import {
  createContext,
  type FC,
  useCallback,
  useContext,
  useState,
} from 'react'
import { useTheme } from '@opallabs/hooks'
import { useEditorElement } from './hooks'
import type { TextEditorContextProps, TextEditorContextValue } from './types'

const TextEditorContext = createContext<TextEditorContextValue | undefined>(
  undefined
)

export const useTextEditor = (): TextEditorContextValue => {
  const context = useContext(TextEditorContext)
  if (!context) {
    throw new Error(
      'No TextEditorContext.Provider found when calling useTextEditor'
    )
  }

  return context
}

export const TextEditorContextProvider: FC<
  React.PropsWithChildren<TextEditorContextProps>
> = ({ children, ...props }) => {
  const theme = useTheme()
  const editorElement = useEditorElement(props.editor)
  const [hyperlinkManagerIsOpen, setHyperlinkManagerOpen] = useState(false)
  const toggleHyperlinkManagerOpen = useCallback(
    () => setHyperlinkManagerOpen((open) => !open),
    []
  )

  return (
    <TextEditorContext.Provider
      value={{
        ...props,
        theme,
        editorElement,
        hyperlinkManager: {
          isOpen: hyperlinkManagerIsOpen,
          toggle: toggleHyperlinkManagerOpen,
          set: setHyperlinkManagerOpen,
        },
      }}
    >
      {children}
    </TextEditorContext.Provider>
  )
}
